import { X } from "lucide-react";
import { twMerge } from "tailwind-merge";

export default function Badge({
  children,
  className,
  isDismissable = true,
  remove,
}: {
  children: React.ReactNode;
  className?: string;
  isDismissable?: boolean;
  remove?: () => void;
}) {
  return (
    <span
      className={twMerge(
        "bg-theme-gradient-from/40 border-theme-gradient-from/70 text-theme-on-glass flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-medium whitespace-pre-wrap",
        className,
      )}
    >
      {children}
      {isDismissable && (
        <X
          onClick={remove}
          size={16}
          className="text-theme-on-glass ml-1 inline-block cursor-pointer"
        />
      )}
    </span>
  );
}
